export const isTranslate = () => {
    return process.env.REACT_APP_LANG === 'en';
};